import { render } from "./ContentPageEdit.vue?vue&type=template&id=c026f860"
import script from "./ContentPageEdit.vue?vue&type=script&lang=js"
export * from "./ContentPageEdit.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__